import React from "react";
import { svgIcons } from "@/components/UI/SvgIcons";
interface ErrorMessageProps {
    message?: string;
    className?: string;
    showIcon?: boolean;
}
const { InfoIcon } = svgIcons
const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, className }) => {
    if (!message) return null;
    return <span className={`text-red-500 text-sm flex items-start gap-1 mt-1 ${className}`}>{InfoIcon} {message}</span>;
};

export default ErrorMessage;
